import React from "react";
import ReactDOM from "react-dom";
import AdminsAccessConfig from "./components/AdminsAccessConfig";
import {
  findHrAdmin,
  findCompanyDetail,
} from "../../infrastructure/repository/company-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { logError } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

export function renderAdminsAccess({ adminLogged, hrEmails, companyData }) {
  const target = document.getElementById("admins-access-config");

  if (target) {
    ReactDOM.render(
      <AdminsAccessConfig
        company={companyData}
        adminLogged={adminLogged}
        hrEmails={hrEmails}
      />,
      target
    );
  }
}

export async function displayAdminsAccessConfig() {
  try {
    const { data: company } = await findCompanyDetail();
    const { data: hrData } = await findHrAdmin();
    const { adminLogged, hrEmails } = hrData;
    renderAdminsAccess({ adminLogged, hrEmails, companyData: company });
  } catch (e) {
    logError(e, `Error to displayAdminsAccessConfig`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
